import { render, staticRenderFns } from "./logo-mineralstoffbehandlung.svg?vue&type=template&id=2c10e97f"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports